﻿import {styled} from "@mui/material/styles";
import {Grid, GridProps} from "@mui/material";

type OriginalGridItemProps = GridProps & {
  isSingleColumn?: boolean;
}

type RootType = OriginalGridItemProps;

const Root = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isSingleColumn'
})(({isSingleColumn}: RootType) => ({
  width: isSingleColumn ? "35%" : "70%",
  marginTop: "2em",
}));

const OriginalGridItem = (props: OriginalGridItemProps) => {
  return <Root item {...props} />
}

export default OriginalGridItem;
